var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('strong',[_vm._v("Instructor/Mentor Directory")])]),_c('b-card-body',[_c('b-button',{attrs:{"size":"sm","variant":"dark"},on:{"click":_vm.getPdf}},[_vm._v("Generate PDF")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }